<div class="tooltip">
  <img
    *ngIf="hintImage === 'type1'"
    class="info-button"
    src="assets/main-game/buttons/btn-info.png"
  />
  <img
    *ngIf="hintImage === 'type2'"
    class="info-btn"
    src="assets/main-game/buttons/info_icon.png"
  />
  <span *ngIf="hintText" class="tooltiptext {{ position }}">
    {{ hintText }}
    <span class="arrow {{ position }}"></span>
  </span>
</div>
